import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const AddIcon = ({ label = 'Add', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M121.9 245h53.9v-63.1a5 5 0 0 1 5-5h63.1v-53.8h-63.1a5 5 0 0 1-5-5V55h-53.9v63.1a5 5 0 0 1-5 5H53.8v53.8h63.1a5 5 0 0 1 5 5z" style="fill:#b1ce5f"/><path d="M175.8 55v63.1a5 5 0 0 0 5 5h63.1v53.8h-63.1a5 5 0 0 0-5 5V245h-53.9v-63.1a5 5 0 0 0-5-5H53.8v-53.8h63.1a5 5 0 0 0 5-5V55h53.9m0-10h-53.9a10 10 0 0 0-10 10v58.1H53.8a10 10 0 0 0-10 10v53.8a10 10 0 0 0 10 10h58.1V245a10 10 0 0 0 10 10h53.9a10 10 0 0 0 10-10v-58.1h58.1a10 10 0 0 0 10-10v-53.8a10 10 0 0 0-10-10h-58.1V55a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M136.9 111.9a5 5 0 0 1-5-5V78.8a5 5 0 0 1 5-5 5.1 5.1 0 0 1 5 5v28.1a5.1 5.1 0 0 1-5 5zM65 148.6a5 5 0 0 1-5-5v-10.3a5 5 0 0 1 5-5 5 5 0 0 1 5 5v10.3a5 5 0 0 1-5 5zm.2 15.2a5 5 0 0 1-5-5v-.8a5.1 5.1 0 0 1 5-5 5 5 0 0 1 5 5v.8a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

AddIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { AddIcon }
